export default __webpack_public_path__ + "static/media/requests.7a5cef03.svg";